import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=588b3755&lang=css"

const __exports__ = script;

export default __exports__